import { FormattedMessage } from 'components/shared/Intl';
import { useState } from 'react';

import { Mode } from '../model';
import { ColorOption } from './Options/ColorOption';
import { Painter } from './Painter/Painter';

export interface IDrawingProps {
  canvas: HTMLCanvasElement;
  width: number;
  onModeChanged: (mode: Mode) => void;
  onSave: (canvas: HTMLCanvasElement) => void;
}

export function Drawing({ canvas, width, onModeChanged, onSave }: IDrawingProps) {
  const [color, setColor] = useState('#F47373');
  return (
    <Painter image={canvas.toDataURL()} initialColor={color} onSave={onSave} width={width}>
      {({ canvas, save }) => (
        <>
          <div className="d-flex pb-3">
            <button
              className="btn btn-discreet-primary me-2"
              onClick={() => {
                onModeChanged(Mode.Preview);
              }}
            >
              <FormattedMessage id="exit" />
            </button>
            <button className="btn btn-success me-2" onClick={save}>
              <FormattedMessage id="save" />
            </button>
            <ColorOption color={color} onChange={setColor} />
          </div>
          <div className="shadow">{canvas}</div>
        </>
      )}
    </Painter>
  );
}
